import React, { useState } from "react";
import { Grid, Typography, useTheme, CardMedia } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { size, COLORS } from "../../utils";
import Enroll from "./Enroll";
import { Link } from "react-router-dom";
import styles from "./TabPanel.module.css";

// 🔸 CourseView: Renders all cards in a responsive grid
function CourseView(props) {
  const { data } = props;
  const [open, setOpen] = useState(false);
  const [enrollData, setEnrollData] = useState({});

  return (
    <Grid
      item
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      mt={size({ p: 4, h: true })}
      rowGap={size({ p: 1 })}
      className={styles.courseviewcontainer}
    >
      {/* Responsive Grid of Cards */}
      <Grid container spacing={2} width={size({ p: 72 })}>
        {Object.keys(data).map((k) => (
          <Grid item key={k} xs={12} sm={6} md={4} lg={3} mb="1rem">
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="space-between"
              height={size({ p: 40, h: true })}
              rowGap={size({ p: 1, h: true })}
              sx={{
                border: `${size({ p: 0.1 })} solid ${COLORS.C2}`,
                borderRadius: size({ p: 0.8 }),
                backgroundColor: COLORS.WHITE + "80",
              }}
              className={styles.coursecard}
            >
              {/* Title */}
              <Grid item width="100%">
                <Typography
                  sx={{
                    fontFamily: "Space Mono",
                    fontSize: size({ p: 1 }),
                    fontWeight: 600,
                    color: COLORS.C1,
                    textAlign: "center",
                    width: "100%",
                    padding: `${size({ p: 1, h: true })} ${size({ p: 1 })}`,
                    backgroundColor: COLORS.C3,
                    borderTopLeftRadius: size({ p: 0.8 }),
                    borderTopRightRadius: size({ p: 0.8 }),
                    borderBottom: `${size({ p: 0.1 })} solid ${COLORS.BLACK}`,
                  }}
                  className={styles.coursetitle}
                >
                  {data[k].name.toUpperCase()}
                </Typography>
              </Grid>

              {/* Image */}
              <Grid item>
                <CardMedia
                  component="img"
                  image={data[k].icon}
                  sx={{
                    width:
                      data[k].icon === "/assets/images/courses/coreldraw.svg"
                        ? size({ p: 9 })
                        : data[k].icon === "/assets/images/courses/indesign.svg"
                        ? size({ p: 10.5 })
                        : size({ p: 12 }),
                    height:
                      data[k].icon === "/assets/images/courses/coreldraw.svg"
                        ? size({ p: 12 })
                        : data[k].icon === "/assets/images/courses/indesign.svg"
                        ? size({ p: 10.5 })
                        : size({ p: 12 }),
                  }}
                  className={styles.courseimage}
                />
              </Grid>

              {/* Actions */}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                height={size({ p: 5, h: true })}
                sx={{
                  borderTop: `${size({ p: 0.15 })} dashed ${COLORS.C2}`,
                }}
                className={styles.courseactions}
              >
                <Grid item width={size({ p: 8 })} className={styles.last}>
                  <Link
                    to={`/courses/${data[k].name
                      .split(" ")
                      .join("")
                      .toLowerCase()}`}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Space Mono",
                        fontSize: size({ p: 0.9 }),
                        fontWeight: 400,
                        color: COLORS.C1 + "E0",
                        textAlign: "center",
                        cursor: "pointer",
                        borderRight: `${size({ p: 0.15 })} solid ${COLORS.C2}`,
                        ":hover": { color: `${COLORS.C2}` },
                      }}
                      className={styles.courseactiontext}
                    >
                      Explore
                    </Typography>
                  </Link>
                </Grid>
                <Grid item width={size({ p: 8 })} className={styles.last1}>
                  <Typography
                    onClick={() => {
                      setEnrollData(data[k]);
                      setOpen(true);
                    }}
                    sx={{
                      fontFamily: "Space Mono",
                      fontSize: size({ p: 0.9 }),
                      fontWeight: 400,
                      color: COLORS.C1 + "E0",
                      textAlign: "center",
                      cursor: "pointer",
                      ":hover": { color: `${COLORS.C2}` },
                    }}
                    className={styles.courseactiontext}
                  >
                    Enroll
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>

      {/* Enroll Dialog */}
      <Enroll onClose={() => setOpen(false)} data={enrollData} open={open} />
    </Grid>
  );
}

// 🔹 CustomTabPanel for conditional rendering
function CustomTabPanel({ value, index, children }) {
  return value === index ? children : null;
}

// 🔸 TabPanel component with swipeable views
const TabPanel = ({ currentTabIndex, setCurrentTabIndex, data }) => {
  const theme = useTheme();

  const handleChangeIndex = (index) => {
    setCurrentTabIndex(index);
  };

  return (
    <SwipeableViews
      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
      index={currentTabIndex}
      onChangeIndex={handleChangeIndex}
    >
      {Object.keys(data).map((key, i) => (
        <CustomTabPanel key={i} value={currentTabIndex} index={i}>
          <CourseView data={data[key]} />
        </CustomTabPanel>
      ))}
    </SwipeableViews>
  );
};

export default TabPanel;
